import { organisationConstants } from '../../_constants/organisation.constants';

const initialState = {
    reset_assessment_loading: false,
    reset_assessment: '',
    reset_assessment_error: false
};

export function resetAssessment(state = initialState, action) {
    switch (action.type) {
        case organisationConstants.REQUEST_RESET_ASSESSMENT:
            return {
                reset_assessment_loading: true,
                reset_assessment: '',
                reset_assessment_error: false
            };
        case organisationConstants.RESPONSE_RESET_ASSESSMENT:
            return {
                reset_assessment_loading: false,
                reset_assessment: action.reset_assessment,
                reset_assessment_error: false
            };
        case organisationConstants.ERROR_RESET_ASSESSMENT:
            return {
                reset_assessment_loading: false,
                reset_assessment: '',
                reset_assessment_error: true
            };
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/organisation/resetAssessment.reducer.js